import type { EffectBuildable, EffectBuilder, EffectiveEffectBuilderSpec } from "../../types/index.ts";

type Options<TBuilder extends EffectBuilder<any>> = Partial<
  Pick<EffectBuildable<TBuilder>, "filter" | "unique" | "restrictTo" | "targetNodeId">
>;

// shortcut less verbose but creates function call at runtime just to get types at build time?!
export const createEffectBuildable = <TBuilder extends EffectBuilder<any>>(
  builder: TBuilder,
  name: string,
  spec: TBuilder extends EffectBuilder<infer TContext>
    ? EffectiveEffectBuilderSpec<TContext["spec"]>
    : EffectiveEffectBuilderSpec<Record<string, never>>,
  options: Options<TBuilder> = {},
): Omit<EffectBuildable<TBuilder>, "nodeId"> => ({
  name,
  builder,
  spec,
  ...options,
});
